module.exports = __webpack_public_path__ + "static/media/header_logo7.d7b25f6d.png";